import React, { useEffect } from 'react';
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { Provider as ReduxProvider } from "react-redux";

import { store } from './redux/store';
import { Main } from './Main';

import 'react-toastify/dist/ReactToastify.css';
import './App.scss';
import { UiModals } from './components/Modals/UiModals';
import { env } from './env';

function App() {
    useEffect(() => {
        if (env().REACT_APP_CHAT_WIDTH?.length > 0) {
            document.documentElement.style.setProperty('--chat-width', env().REACT_APP_CHAT_WIDTH)
        }
        if (env().REACT_APP_CHAT_BACKGROUND) {
            document.documentElement.style.setProperty(
                '--messenger-chat-background',
                env().REACT_APP_CHAT_BACKGROUND
            );
        }

        if (env().REACT_APP_MAIN_COLOR) {
            document.documentElement.style.setProperty(
                '--messenger-blue',
                env().REACT_APP_MAIN_COLOR
            );
        }
    }, []);
    return <ReduxProvider store={store}>
            <UiModals />
            <BrowserRouter>
                <Routes>
                    <Route
                        path="*"
                        element={<Main />}
                    />
                </Routes>
            </BrowserRouter>
            <ToastContainer/>
        </ReduxProvider>;
}

export default App;
